import { Box } from "@mui/material";

import {
  AddCarrierButton,
  CarrierSearchField,
  CarrierSortSelect,
  HasIssuesCheckbox,
} from "../components";

interface CarrierListFiltersProps {
  search: string;
  onSearchChange: (search: string) => void;
}

export const CarrierListFilters = ({
  search,
  onSearchChange,
}: CarrierListFiltersProps): React.JSX.Element => (
  <Box display="flex" flexDirection="column" gap={1} p={2}>
    <CarrierSearchField value={search} onChange={onSearchChange} />
    <Box
      display="flex"
      alignItems="stretch"
      justifyContent="space-between"
      gap={1}
    >
      <HasIssuesCheckbox />
      <CarrierSortSelect />
      <AddCarrierButton />
    </Box>
  </Box>
);
